import { render, staticRenderFns } from "./LoanAdvisory.vue?vue&type=template&id=87190d10"
import script from "./LoanAdvisory.vue?vue&type=script&lang=js"
export * from "./LoanAdvisory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports